webpackJsonp([270306759330599],{

/***/ 1012:
/***/ (function(module, exports) {

	module.exports = {"data":{"contributionsJson":{"name":"modern","www_url":"http://www.deptford.tv","thema":"modern","issue_month":"April","issue_year":2008,"issue_date":200804,"artist":"deptfordtv","location":"Großbritannien","email":"info@deptford.tv","id":"contribution_357","media_type":"moving_image","position_in_section":1,"media_uri":"media/2008/April/moving_image/modern.mov","media_th_uri":"","still_image_count":4,"moving_image_count":1,"textz_count":9,"soundz_count":0}},"pathContext":{"id":"contribution_357"}}

/***/ })

});


// WEBPACK FOOTER //
// path---issue-200804-moving-image-1-fa9a704a5cd5a380ba53.js